import { access } from 'fs'
import React, { useContext, useEffect, useState, useRef } from 'react'
import GlobalContext from '../../../../contexts/globalContext';
import { getToken, postSendOtp, postValidateOtp } from '../../../../services/mentoriaService'
import Button from '../../../atoms/button/button'
import ImageBlobBackground from '../image-blob-background/imageBlobBackground'
import MentoriaOtp from '../mentoria-otp/mentoriaOtp';
import './tratamientoDatos.scss'

interface TratamientoDatosProps {
    blobImage: string;
    setAcceptTratamiento: any;
    otpIcons: Array<string>;
}

const TratamientoDatos = ({ blobImage, setAcceptTratamiento, otpIcons }: TratamientoDatosProps) => {
    const [rechazar, setReachazar] = useState(false);
    const [aceptar, setAceptar] = useState(false);
    const dockRef = useRef(null);
    const Context = useContext(GlobalContext);
    const onClickReject = () => {
        setReachazar(true);
        setAceptar(false);
    }

    const { email } = Context.gigyaContext.gigyaAccount.profile;
    const { mobile } = Context.gigyaContext.gigyaAccount.data;

    const startDiagnostic = () => {
        setReachazar(false);
        setAcceptTratamiento(true);
        setAceptar(true);
    }

    const showOtpScreen = () => {
        setReachazar(false);
        setAceptar(true);
    }

    const checkOtp = async () => {
        let userOtpCode = prompt(
            "Por favor ingresa el código que enviamos a tu célular o correo electrónico:",
            ""
        );
        if (userOtpCode == null || userOtpCode == "") {
            alert("¡Ups! No ingresaste ningún código OTP");
        } else {
            try {
                let token;
                if (Context.gigyaContext.gigyaAccount) {
                    token = await getToken(Context.gigyaContext.gigyaAccount.UID);
                } else {
                    return;
                }
                postValidateOtp(token.id_token, {
                    cellPhone: mobile,
                    codeOtp: userOtpCode,
                    email: email,
                }).then((res) => {
                    if (res.data.status === 200) {
                        startDiagnostic();
                    } else {
                        alert("¡Ups! parece que no es el código OTP correcto, por favor intenta de nuevo.");
                    }
                });
            } catch (error) {
                console.error(error);
            }
        }
    };

    const onClickReset = () => {
        setReachazar(false);
        setAceptar(false);
    }

    useEffect(() => {
        if (dockRef && dockRef.current) {
            const y = dockRef.current.getBoundingClientRect().top + window.pageYOffset - 100;
            window.scrollTo({
                top: y
            });
        }
    }, [rechazar, aceptar])


    return (
        <div className="tratamiento-datos" ref={dockRef}>
            {(!rechazar && !aceptar) ? <>
                <body className="tratamiento-datos__body">
                    <div className="tratamiento-datos__body__background">
                        <h3 className="tratamiento-datos__body__title">Autorización de tratamiento de datos personales <br />Programa de Mentoría Financiera</h3>
                        <div className="tratamiento-datos__body__text">
                            <p>
                                Indícanos si en tu calidad de: afiliado, proveedor, usuario, cliente, aliado, autorizas a Comfama para conocerte mejor y comunicarnos contigo a través de los canales de contacto que nos has suministrado directamente o a través de terceros. Esto incluye:
                            </p>
                            <ul className='list'>
                                <li>Contactarte para conocer tu opinión sobre la prestación de nuestros servicios.</li>
                                <li>Tratar tus datos personales para diseñar y ofrecerte servicios y programas personalizados nuestros y de terceros.</li>
                                <li>Verificarte y analizarte en las diferentes fuentes o consultas públicas para el cumplimiento de obligaciones legales y contractuales.</li>
                                <li>Consultar en bases de datos crediticias o no, públicas o privadas, mi situación patrimonial.</li>
                                <li>El buen desarrollo del servicio, programa, evento, contrato.</li>
                                <li>Almacenar, consultar, compartir, verificar, reportar, actualizar y rectificar tus datos personales al interior de Comfama o ante cualquier otra entidad nacional o extrajera que maneje o administre bases de datos, preste servicios de verificación o realice análisis de administración de riesgos.</li>
                                <li>Transferir o transmitir tus datos a terceros dentro y/o fuera de Colombia.</li>
                                <li>Informar a mi empleador cuando este sea el patrocinador sobre mi evolución en el programa, cumplimiento de citas y compromisos.</li>
                            </ul>
                            <p>
                                Esta autorización incluye el tratamiento de datos personales de carácter biométrico y aplicará aun cuando no se haya perfeccionado una relación contractual o después de finalizada la misma y permite que el tratamiento de los datos sea realizado de manera segura y confidencial por COMFAMA o por terceros.
                            </p>
                            <p>
                                Recuerda que no estás obligado a diligenciar los datos personales de menores de edad o información tuya y de tus beneficiarios que sea sensible.
                            </p>
                            <p>Con esta autorización además, manifiestas que has sido informado acerca de la política de protección de datos personales de COMFAMA que se encuentran en la página web www.comfama.com y que has sido informado acerca de los derechos que tengo para proteger mis datos y que puedo ejercerlo a través del correo electrónico protecciondatospersonales@comfama.com.co</p>
                        </div>
                    </div>
                    <span className="tratamiento-datos__body__info">
                        Para conocer la politica de protección de datos de personas de Comfama, <a className="tratamiento-datos__body__link" href='https://serviciosenlinea.comfama.com/webinicio/HabeasData.htm' target='_blank'>haz clic acá</a>
                    </span>
                    {/* TODO: Estos controles  */}
                    <div className="tratamiento-datos__body__controls">
                        <Button
                            type={"button"}
                            classname="tratamiento-datos__body__controls__button"
                            text="Rechazar"
                            isDisabled={false}
                            gtmMark="primary"
                            onClickAction={onClickReject}
                        />
                        <Button
                            onClickAction={showOtpScreen}
                            type={"button"}
                            classname="tratamiento-datos__body__controls__button"
                            text="Aceptar"
                            isDisabled={false}
                            gtmMark="secondary"
                        />
                    </div>
                </body>
            </> : (!aceptar && rechazar) ?
                <>
                    <div className="tratamiento-datos__rejected">
                        <ImageBlobBackground blobImage={blobImage} image={'https://images.ctfassets.net/gkhyeghj07ak/7lYcsIDSFPv1tHszS4GL0c/1bb60a2be99a617169fa93d4826a4a97/tus-propositos.svg'} />
                        <h2 className="tratamiento-datos__rejected__title">Elegiste no permitir el tratamiento de tus datos personales</h2>
                        <p className="tratamiento-datos__rejected__text">Por lo tanto no podemos continuar con el diagnóstico</p>
                    </div>
                    <h3 className='tratamiento-datos__rejected__subtitle'>¿Quieres regresar y aprobar el tratamiento de tus datos?</h3>
                    <div className="tratamiento-datos__body__controls">
                        <Button
                            type={"button"}
                            classname="tratamiento-datos__body__controls__button"
                            text="Sí"
                            isDisabled={false}
                            gtmMark="primary"
                            onClickAction={onClickReset}
                        />
                        <Button
                            onClickAction={onClickReset}
                            type={"button"}
                            classname="tratamiento-datos__body__controls__button"
                            text="No"
                            isDisabled={false}
                            gtmMark="secondary"
                        />
                    </div>
                </> :
                <>
                    <MentoriaOtp otpIcons={otpIcons} handleCorrectCode={startDiagnostic} />
                </>
            }
        </div>
    )
}

export default TratamientoDatos